import { defineMessages } from 'react-intl';

const prefix = 'app.containers.TranslationSettings.MergeKeys.AddMergeKeyDialog';

export const messages = defineMessages({
  createError: {
    id: `${prefix}.createError`,
    defaultMessage: 'Could not add merge key',
  },
  createSuccess: {
    id: `${prefix}.createSuccess`,
    defaultMessage: 'Merge key added',
  },
  errorLoadingAvailable: {
    id: `${prefix}.errorLoadingAvailable`,
    defaultMessage:
      'There was an error loading available merge keys. Try again later.',
  },
  noKeysAvailable: {
    id: `${prefix}.noKeysAvailable`,
    defaultMessage: 'All available merge keys have already been added.',
  },
  noMatches: {
    id: `${prefix}.noMatches`,
    defaultMessage: 'No keys match "{query}"',
  },
  searchPlaceholder: {
    id: `${prefix}.searchPlaceholder`,
    defaultMessage: 'Search available keys',
  },
});
